export const LOGOUT_EVENT_NAME = 'logout';

export const emitLogout = () => {
  document.dispatchEvent(new CustomEvent(LOGOUT_EVENT_NAME));
};

export const listenLogout = (
  listener: (
    this: Document,
    event: DocumentEventMap[typeof LOGOUT_EVENT_NAME],
  ) => any,
) => {
  document.addEventListener(LOGOUT_EVENT_NAME, listener);
  return () => document.removeEventListener(LOGOUT_EVENT_NAME, listener);
};
